import { lazy } from 'react';

import { RouteGuard } from '@core/components/navigation/RouteGuard';
import DashboardLayout from '@core/layouts/DashboardLayout';
import { ROUTES } from '@core/utils/constants';

const Crm = lazy(() => import('@crm/index'));
const BoardStatusesPage = lazy(() => import('@crm/ui/pages/BoardStatusesPage'));

const CrmRouter = {
  element: (
    <RouteGuard mode="protected">
      <DashboardLayout />
    </RouteGuard>
  ),
  children: [
    { path: ROUTES.crm.root, element: <Crm /> },
    { path: ROUTES.crm.statuses, element: <BoardStatusesPage /> },
  ],
};

export default CrmRouter;
